function push_to_queue(array) {
  let items = [];
  jQuery(".box_product_wrapper").addClass("loading");
  let newArray = array.split(",");
  for (var i = 0; i < newArray.length; i++) {
    let product = newArray[i].split(":");
    let pro_item = {'id': product[0], 'quantity': product[1]};
    items.push(pro_item);
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({'items':items})
  })
  .then(response => {
    jQuery(".product-form__buttons .product-form__submit").trigger("click");
    setTimeout(function () {
    $(".var_button").removeClass("loading");
    $(".var_button").find(".loading-overlay__spinner").addClass("hidden");
    }, 1000);  
    return;
  })
  .catch((error) => {
    jQuery(".multi_qty_error").show();
    // console.log(error,"select available variant!");
    jQuery(".pro_error").addClass("alert--error").text(error.responseJSON.description);      
  });
}